'use strict';

const scrollAnimate = require('../components/scrollAnimate');

module.exports = {
    init: function () {
        $('.pause-icon').on('click', function() {
            const $this = $(this),
                $carousel = $this.closest('.carousel');

            $carousel.carousel('pause');
            $this.addClass('d-none').siblings('.play-icon').removeClass('d-none');
        });

        $('.play-icon').on('click', function() {
            const $this = $(this),
                $carousel = $this.closest('.carousel');

            $carousel.carousel();
            $this.addClass('d-none').siblings('.pause-icon').removeClass('d-none');
        });

        // for FAQ's accordion
        $(document).on('click', '.accordion-button', function() {
            $(this).closest('.accordion-item').toggleClass('active');
        });

        // Navigate to shipping section in FAQ's page based on URL parameter
        $(window).on('load', function() {
            const faqUrl = new URL(window.location.href),
                scrollSection = faqUrl.searchParams.get('scroll'),
                scrollId = `#${scrollSection}`;
            if (scrollSection) {
                $(scrollId).addClass('active');
                scrollAnimate($(scrollId));
            }
        });
    }
}